import React from 'react';

import Form from '@/components/Form';

import { ECustomerAge } from '@/helpers/API/requests/interfaces/customer';

import Layout from './Layout';

import { TPersonalizationStepForm } from './interfaces';
import LocaleText from '@/components/Intl/LocaleText';

const Age: React.FC<TPersonalizationStepForm> = ({ formRef }) => (
    <Layout title='form.personalizationStep.age.title'>
    {Object.values(ECustomerAge).map((value: string) => (
        <Form.RadioButton
            key={value}
            name='age'
            value={value}
            onChanged={() => {
                formRef.current!.next();
            }}
        >
            <LocaleText>{'form.personalizationStep.radio.' + value}</LocaleText>
        </Form.RadioButton>
    ))}
    </Layout>
);

export default Age;